<template>
  <div class="card">
    <div class="card-header">
      <h4>Beschreibung</h4>
    </div>
    <div class="card-body">
      <textarea v-model="description" class="form-control" maxlength="300">
      </textarea>
      {{ description.length }} / 300
    </div>
    <div class="card-footer">
      <button @click="save()" class="btn btn-primary">
        <i class="fas fa-save"></i> Speichern
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  created() {
    this.description = this.value.description || "";
  },
  data() {
    return {
      description: ""
    };
  },
  methods: {
    save() {
      this.$http
        .patch(this.value.update_url, {
          description_update: this.description
        })
        .then(() => {
          this.$notify({
            title: "Beschreibung gespeichert",
            type: "success"
          });
        });
    }
  },
  watch: {
    value() {
      this.description = this.value.description || "";
    }
  }
};
</script>

<style></style>
